import { render, staticRenderFns } from "./DefaultContainerAdmin.vue?vue&type=template&id=60241bf0"
import script from "./DefaultContainerAdmin.vue?vue&type=script&lang=js"
export * from "./DefaultContainerAdmin.vue?vue&type=script&lang=js"
import style0 from "./DefaultContainerAdmin.vue?vue&type=style&index=0&id=60241bf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports